import { css } from 'styled-components';
import token from 'styled-token';
import { CARD_TYPES } from '../../constants';
import { spacingMixin } from '../spacingMixin';
var interactiveCSS = function interactiveCSS(props) {
  if (!props.interactive) {
    return token({
      backgroundColor: 'Card.backgroundColor'
    }, function (_ref) {
      var backgroundColor = _ref.backgroundColor;
      return css(["background-color:", ";"], backgroundColor);
    })(props);
  }
  return token({
    backgroundColor: 'Card.backgroundColor',
    hoverBackgroundColor: 'Card.interactive.backgroundColor.hover',
    pressedBackgroundColor: 'Card.interactive.backgroundColor.pressed',
    transitionProperty: 'Card.interactive.transitionProperty',
    transitionDuration: 'Card.interactive.transitionDuration',
    transitionTimingFunction: 'Card.interactive.transitionTimingFunction',
    activeBorderColor: 'Card.interactive.borderColor.active',
    hoverBorderColor: 'Card.interactive.borderColor.hover',
    pressedBorderColor: 'Card.interactive.borderColor.pressed',
    pressedBorderWidth: 'Card.interactive.borderWidth.pressed'
  }, function (_ref2) {
    var backgroundColor = _ref2.backgroundColor,
      hoverBackgroundColor = _ref2.hoverBackgroundColor,
      pressedBackgroundColor = _ref2.pressedBackgroundColor,
      _ref2$transitionPrope = _ref2.transitionProperty,
      transitionProperty = _ref2$transitionPrope === void 0 ? 'background-color, box-shadow' : _ref2$transitionPrope,
      _ref2$transitionDurat = _ref2.transitionDuration,
      transitionDuration = _ref2$transitionDurat === void 0 ? 0.2 : _ref2$transitionDurat,
      _ref2$transitionTimin = _ref2.transitionTimingFunction,
      transitionTimingFunction = _ref2$transitionTimin === void 0 ? 'ease' : _ref2$transitionTimin,
      activeBorderColor = _ref2.activeBorderColor,
      hoverBorderColor = _ref2.hoverBorderColor,
      pressedBorderColor = _ref2.pressedBorderColor,
      _ref2$pressedBorderWi = _ref2.pressedBorderWidth,
      pressedBorderWidth = _ref2$pressedBorderWi === void 0 ? 2 : _ref2$pressedBorderWi;
    return css(["background-color:", ";cursor:pointer;outline:none;position:relative;transition-property:", ";transition-duration:", "s;transition-timing-function:", ";&:hover{background-color:", ";&:after{border-color:", ";}}&:active{background-color:", ";&:after{border-color:", ";}}&:after{border:", "px solid ", ";content:'';display:none;pointer-events:none;position:absolute;speak:none;z-index:1;}&[aria-pressed='true']:after{display:block;}@media (prefers-reduced-motion:reduce){&{transition:none;}}"], backgroundColor, transitionProperty, transitionDuration, transitionTimingFunction, hoverBackgroundColor, hoverBorderColor, pressedBackgroundColor, pressedBorderColor, pressedBorderWidth, activeBorderColor);
  })(props);
};
var borderCSS = function borderCSS(props) {
  if (props.appearance === 'borderless') {
    return token({
      borderColor: 'Card.borderColor'
    }, function (_ref3) {
      var borderColor = _ref3.borderColor;
      return css(["border:0 solid ", ";&[aria-pressed='true']{border-color:transparent;}&:after{bottom:0;left:0;right:0;top:0;}"], borderColor);
    })(props);
  }
  return token({
    borderColor: 'Card.borderColor',
    borderWidth: 'Card.borderWidth'
  }, function (_ref4) {
    var borderColor = _ref4.borderColor,
      _ref4$borderWidth = _ref4.borderWidth,
      borderWidth = _ref4$borderWidth === void 0 ? 1 : _ref4$borderWidth;
    return css(["border:", "px solid ", ";&[aria-pressed='true']{border-color:transparent;}&:after{bottom:-1px;left:-1px;right:-1px;top:-1px;}"], borderWidth, borderColor);
  })(props);
};
var primaryCSS = function primaryCSS(props) {
  var cardType = props.cardType,
    cardDirection = props.cardDirection;
  if (cardType !== CARD_TYPES.primary) {
    return '';
  }
  return token({
    borderColor: 'Card.borderColorPrimary',
    borderWidth: 'Card.borderWidthPrimary'
  }, function (_ref5) {
    var borderColor = _ref5.borderColor,
      _ref5$borderWidth = _ref5.borderWidth,
      borderWidth = _ref5$borderWidth === void 0 ? 3 : _ref5$borderWidth;
    return css(["border-", ":", "px solid ", ";&[aria-pressed=\"true\"]{border-", ":", "px solid ", ";}&:after{", ":-", "px;}"], cardDirection, borderWidth, borderColor || '', cardDirection, borderWidth, borderColor || '', cardDirection, borderWidth);
  })(props);
};
var boxShadowCSS = function boxShadowCSS(props) {
  if (!props.interactive && !props.cardElevation) {
    return '';
  }
  if (!props.interactive && props.cardElevation) {
    return token('shadows.shadow100', function (boxShadow) {
      return "box-shadow: " + (boxShadow || '') + ";";
    })(props);
  }
  if (props.interactive && !props.cardElevation) {
    return token({
      focusShadow: 'shadows.focus'
    }, function (_ref6) {
      var focusShadow = _ref6.focusShadow;
      return css(["&:focus-visible{box-shadow:", ";}"], focusShadow);
    })(props);
  }
  return token({
    elevationShadow: 'shadows.shadow100',
    hoverElevationShadow: 'shadows.shadow200',
    focusShadow: 'shadows.focus'
  }, function (_ref7) {
    var elevationShadow = _ref7.elevationShadow,
      hoverElevationShadow = _ref7.hoverElevationShadow,
      focusShadow = _ref7.focusShadow;
    return css(["box-shadow:", ";&:hover{box-shadow:", ";}&:active:not(:has(:active)){box-shadow:none;}&:focus-visible{box-shadow:", ";}&:focus-visible:hover{box-shadow:", ";}&:focus-visible:active{box-shadow:", ";}&[aria-pressed='true'],[aria-pressed='true']:hover,[aria-pressed='true']:active{box-shadow:none;}&[aria-pressed='true']:focus-visible,[aria-pressed='true']:focus-visible:hover,[aria-pressed='true']:focus-visible:active{box-shadow:", ";}"], elevationShadow, hoverElevationShadow, elevationShadow + ", " + focusShadow, hoverElevationShadow + ", " + focusShadow, focusShadow, focusShadow);
  })(props);
};

/** @class CardMixin */
/** @method */
export var CardMixin = function CardMixin(props) {
  return token({
    borderRadius: 'Card.borderRadius',
    padding: 'Card.padding'
  }, function (_ref8) {
    var borderRadius = _ref8.borderRadius,
      _ref8$padding = _ref8.padding,
      padding = _ref8$padding === void 0 ? 'sm' : _ref8$padding;
    return css(["border-radius:", "px;&:after{border-radius:", "px;}", " ", " ", " ", " ", ""], borderRadius || 0, borderRadius || 0, spacingMixin(Object.assign({
      padding: padding
    }, props)), interactiveCSS(props), borderCSS(props), primaryCSS(props), boxShadowCSS(props));
  })(props);
};